module.exports = __webpack_public_path__ + "img/bosspack_dfod_dg_k.cc027517.png";